<template>
    <v-container>
        <!-- header info -->
        <v-row class="pa-4 pb-2">
            <h3>Select bookings for the change</h3>
            <v-spacer></v-spacer>
            {{ selected_message }}
        </v-row> 
        <v-row>
            <v-data-table 
                dense 
                hide-default-footer
                show-select
                return-object

                v-model="selected_data"
                @input="enterSelect"
                :headers="getHeaders()" 
                :items="data"
                item-key="huov_code"
                :disable-pagination=true>
            </v-data-table>
        </v-row>
        
        <v-row>
            <v-divider></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" small v-on:click="closeSelect">Close</v-btn> 
        </v-row>
    </v-container>
</template>

<script>
    export default {
        components: {
        },  
        props: {
            huis_encrid: {
                type: String,
                default: '',
                required: false
            },
            howz_encrid: {
                type: String,
                default: '',
                required: false
            },
            data: {
                type: Array,
                required: true
            },
            selected_data: {
                type: Array,
                required: true
            },
            selected_message: {
                type: String,
                required: true
            }
        },             
        data() {
            return {
            }
        },
        methods: {                       
            getHeaders() {
                return [
                    { text: "Booking", value: "huov_code", sortable: true},
                    { text: "Partner", value: "inpt_oms", sortable: false},
                    { text: "Status", value: "huov_status", sortable: false},
                    { text: "Book date", value: "huov_book_date", sortable: false},
                    { text: "Travel party", value: "huov_travelparty", sortable: false},
                    { text: "Arrival", value: "huov_arrival", sortable: false},
                    { text: "Departure", value: "huov_departure", sortable: false}, 
                    { text: "Guest", value: "huov_guest", sortable: false},
                    { text: "Country", value: "huov_country", sortable: false},
                    { text: "Payment status", value: "huov_payment", sortable: false},
                ];
            },	
            enterSelect() {
                this.$emit('updateField', { field: 'selected_huovs', value: this.selected_data });
            },
            closeSelect() {
                this.$emit("updateField", { field: "showChange", value: true }); 
                this.$emit("updateField", { field: "showSelection", value: false }); 
            },
        },
    }

</script>

<style scoped>
    .row-pointer {
      cursor: pointer;
    }
    .button-margin-lr{
        margin-left: 4px;
        margin-right: 4px;
    }
    .button-margin-l{
        margin-left: 4px;
    }  
    .button-margin-r{
        margin-right: 6px;
    }  
    .gridbutton:hover{
        border: 1px solid rgba(169, 169, 169, 1) !important;
    }
</style>